import {ComponentRef, Injectable} from '@angular/core';
import {ExceptionComponent} from './exception.component';
import {Observable, of} from 'rxjs';
import {delay, switchMap} from 'rxjs/operators';
import {InjectionService} from '../../injections/injection/injection.service';

@Injectable()
export class ExceptionService {
    constructor(private injectionService: InjectionService) {
    }

    /**
     *
     * @param description
     * @param title
     */
    public create(description: string, title: string): Observable<ComponentRef<ExceptionComponent>> {
        return this.injectionService.post<ExceptionComponent>(ExceptionComponent).pipe(switchMap((componentRef) => {
            componentRef.instance.description = description;
            componentRef.instance.loaded = false;
            componentRef.instance.title = title;

            return of(componentRef).pipe(delay(500));
        }));
    }

    /**
     *
     * @param componentRef
     */
    public destroy(componentRef: ComponentRef<ExceptionComponent>): void {
        this.injectionService.delete<ExceptionComponent>(componentRef);
    }

    /**
     *
     * @param componentRef
     */
    public load(componentRef: ComponentRef<ExceptionComponent>): Observable<ComponentRef<ExceptionComponent>> {
        componentRef.instance.loaded = true;

        return of(componentRef).pipe(delay(500));
    }

    /**
     *
     * @param componentRef
     */
    public unload(componentRef: ComponentRef<ExceptionComponent>): Observable<ComponentRef<ExceptionComponent>> {
        componentRef.instance.loaded = false;

        return of(componentRef).pipe(delay(500));
    }
}
